import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { v4 } from 'uuid';
import { onActions } from '../../utils/helpers/redux.helper';
import {
  ActionsEnum,
  addAccountUser,
  addAccountUserNetwork,
  deleteAccountUser,
  deleteAccountUserNetwork,
  updateAccountUser,
  updateAccountUserNetwork,
} from './account-user-data.actions';
import { AccountUser } from './account-user.model';

@Injectable()
export class AccountUserDataDispatcher {
  constructor(private _store: Store<any>, private _actions: Actions) {}

  addAccountUser(accountUser: AccountUser): Observable<any> {
    const dispatchId = v4();

    this._store.dispatch(addAccountUser(accountUser));
    this._store.dispatch(addAccountUserNetwork(dispatchId, accountUser));

    return onActions(
      this._actions,
      [
        ActionsEnum.ADD_ACCOUNT_USER_NETWORK_SUCCESS,
        ActionsEnum.ADD_ACCOUNT_USER_NETWORK_ERROR,
      ],
      dispatchId
    );
  }

  updateAccountUser(
    prevAccountUser: AccountUser,
    currentAccountUser: AccountUser
  ): Observable<any> {
    const dispatchId = v4();

    this._store.dispatch(updateAccountUser(currentAccountUser));
    this._store.dispatch(
      updateAccountUserNetwork(dispatchId, prevAccountUser, currentAccountUser)
    );

    return onActions(
      this._actions,
      [
        ActionsEnum.UPDATE_ACCOUNT_USER_NETWORK_SUCCESS,
        ActionsEnum.UPDATE_ACCOUNT_USER_NETWORK_ERROR,
      ],
      dispatchId
    );
  }

  removeAccountUser(accountUser: AccountUser): Observable<any> {
    const dispatchId = v4();

    this._store.dispatch(deleteAccountUser(accountUser));
    this._store.dispatch(deleteAccountUserNetwork(dispatchId, accountUser));

    return onActions(
      this._actions,
      [
        ActionsEnum.DELETE_ACCOUNT_USER_NETWORK_SUCCESS,
        ActionsEnum.DELETE_ACCOUNT_USER_NETWORK_ERROR,
      ],
      dispatchId
    );
  }
}
